import { render, staticRenderFns } from "./AlpariForm.vue?vue&type=template&id=e013f326&scoped=true&lang=pug&"
import script from "./AlpariForm.vue?vue&type=script&lang=js&"
export * from "./AlpariForm.vue?vue&type=script&lang=js&"
import style0 from "./AlpariForm.vue?vue&type=style&index=0&id=e013f326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e013f326",
  null
  
)

export default component.exports